import React, { useEffect, useRef } from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { useAuth, hasPerm } from "@/context/AuthContext";
import { OfferEditor } from "@/components/offers/OfferEditor";

export default function OfferEditorPage() {
  const { cardId, offerId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const dirtyRef = useRef(false);

  useEffect(() => {
    const h = (e) => { if (dirtyRef.current) { e.preventDefault(); e.returnValue = ""; } };
    window.addEventListener("beforeunload", h);
    return () => window.removeEventListener("beforeunload", h);
  }, []);

  // Buyers never reach the admin offer editor.
  if (!hasPerm(user, "offers.edit")) return <Navigate to="/offers" replace />;

  const leave = () => {
    if (dirtyRef.current && !window.confirm("You have unsaved changes. Leave without saving?")) return;
    navigate("/offers");
  };

  const onSaved = () => {
    dirtyRef.current = false;
    qc.invalidateQueries({ queryKey: ["offer-cards"] });
    qc.invalidateQueries({ queryKey: ["offer", offerId] });
    navigate("/offers");
  };

  return (
    <div className="space-y-5">
      <button onClick={leave} data-testid="back-to-offers" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-4 w-4" /> Back to Offers
      </button>
      <div className="rounded-xl border border-white/[0.08] bg-[#141417] p-5">
        <OfferEditor offerId={offerId} onSaved={onSaved} onDirtyChange={(d) => { dirtyRef.current = d; }} />
      </div>
    </div>
  );
}
